module.exports = __webpack_public_path__ + "05_short_brown.7ad8fc3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_short_brown.png
// module id = P4b/
// module chunks = 0